import React, { type ReactElement } from 'react';
import DOMPurify from 'dompurify';
import Alert from 'atom-components/alert';
import styles from './index.module.scss';

type Props = { description: string | undefined };

/**
 * Display the report description as an info alert
 *  - not visible in printing
 *  - only renders if a description is provided
 *  - expects html like content
 */
export default function ReportDescription({ description }: Props): ReactElement | null {
  if (!description) return null;

  return (
    <Alert variant="info" className={styles.descriptionAlert}>
      <div
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(description, { ADD_ATTR: ['target'] })
        }}
      />
    </Alert>
  );
}
